export const get_agent_name = (referral_code: string): string => {
    const HDBANK_REFERRAL_CODE = import.meta.env.VITE_HDBANK_REFERRAL_CODE;
    const COCACOLA_REFERRAL_CODE = import.meta.env.VITE_COCACOLA_REFERRAL_CODE;

    if (HDBANK_REFERRAL_CODE.split(",").includes(referral_code) || referral_code === COCACOLA_REFERRAL_CODE) {
        return import.meta.env.VITE_PIPECAT_VIETNAMESE_AGENT_NAME || "my-vietnamese-agent";
    }

    // Default agent name if no specific referral code matches
    return import.meta.env.VITE_PIPECAT_AGENT_NAME;
}